// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609170604/js/" + chunkId + "." + {"44":"d9fb9eec","225":"6747e418","481":"92a3561d","486":"b73bac57","770":"f2ffb44e"}[chunkId] + ".0.505445314884224.chunk.js";
};